module.exports = __webpack_public_path__ + "static/media/30OIOS8.12eb6524.jpg";